import { SlArrowDown } from "react-icons/sl";
import { Link } from "react-router-dom";
import { Logout, Searchinput, Text } from "../index";
import Image from "../../assets/image";
import Functions from "./index.function";
import localimgpath from "../../js/localimgpath";
import { fontSizes } from "../../constants/constants";
export default function SearchbarCom() {
  const {
    Icons,
    toggleSearchPopup,
    showSearchPopup,
    userprofile,
    navigate,
    allNotifications,
    dispatch,
    logout,
    setIslogout,
    handleMouseLeave,
    handleNotificationMouseEnter,
    notifications,
    handleNotificationMouseLeave,
    handleMouseEnter,
    profileName,
    notificationColorData,
    profileimage,
    Profiler,
    islogout,
    setProfiler,
    TextWeight,
  } = Functions();
  return (
    <div className="bg-[#000000] fixed top-0 left-0 z-50 flex w-full xs:gap-3 xs:justify-end xs:pr-2 justify-between items-center sm:px-5 xs:py-2 sm:py-2 lg:px-10 lg:py-2">
      <div className="xs:hidden sm:block">
        <Link to={"/"}>
          <img
            className="w-12 h-12 sm:w-[55px] sm:h-[55px]"
            src={Image.newlogo}
            alt="Logo"
          />
        </Link>
      </div>
      <div className="sm:flex items-center xs:gap-1 sm:gap-2 lg:gap-5 xs:w-[53%] sm:w-[60%] lg:w-5/12 xs:hidden ">
        <Link to={"/dashboard"}>
          <img
            src={Icons?.dashboardHomeIcon}
            alt="dashboardHomeIcon"
            className="xs:w-3 sm:w-4 lg:w-5"
          />
        </Link>
        <div className="relative w-full">
          <div className="">
            <Searchinput
              type="search"
              name="search"
              roundedClass="xs:rounded-[4px] sm:rounded-md lg:rounded-lg"
              placeholder="Search Your Actor Actress Projects Teams"
              icon={Icons.searchIcon}
              iconStyle="xs:w-2.5 xs:h-2.5 sm:w-4 sm:h-4 h-5 w-6"
            />
          </div>
        </div>
      </div>
      <div className="xs:flex sm:hidden bg-raisinBlack rounded-full w-5 h-5  xs:justify-center xs:items-center">
        <button onClick={toggleSearchPopup}>
          <img
            src={Icons.searchIcon}
            className="xs:w-2.5 xs:h-2.5 text-gray-600"
          />
        </button>
      </div>

      {/* Popup on icon click */}
      {showSearchPopup && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
          onClick={toggleSearchPopup}
        >
          <div className="bg-white p-4 rounded-lg w-11/12 max-w-sm relative">
            <button
              className="absolute top-0 right-2 text-gray-500"
              onClick={toggleSearchPopup}
            >
              &times;
            </button>
            <Searchinput
              type="search"
              name="search"
              roundedClass="xs:rounded-[4px] sm:rounded-md lg:rounded-lg"
              placeholder="Search Your Actor Actress Projects Teams"
              icon={Icons.searchIcon}
              iconStyle="xs:w-2.5 xs:h-2.5 sm:w-4 sm:h-4 h-5 w-6"
            />
          </div>
        </div>
      )}
      <div className="flex relative justify-center items-center xs:gap-1 sm:gap-3 lg:gap-5">
        <div
          className={`rounded-full flex justify-center items-center ${
            userprofile?.role === "fan"
              ? "cursor-default"
              : "transition-transform duration-300 hover:scale-110 cursor-pointer"
          } `}
          onClick={() => {
            navigate(userprofile?.role === "fan" ? null : "/chat");
          }}
        >
          <img
            src={Icons?.emailDashboardIcon}
            alt="dashboardHomeIcon"
            className="xs:w-5 sm:w-6 lg:w-6 lg:h-4"
          />
        </div>
        <div className="relative" onClick={handleNotificationMouseEnter}>
          <div className="rounded-full flex justify-center items-center cursor-pointer">
            {allNotifications?.notifications?.length > 0 ? (
              <img
                src={Icons?.notificationInactiveIcon}
                alt="notificationDashboardIcon"
                className="xs:w-3.5 sm:w-4 lg:w-4"
              />
            ) : (
              <img
                src={Icons?.notificationEmptyIcon}
                alt="notificationEmptyIcon"
                className="xs:w-3.5 sm:w-4 lg:w-4"
              />
            )}
            {allNotifications?.notifications?.filter((n) => !n.read)?.length >
              0 && (
              <span className="bg-[#D93939] absolute xs:!text-[5px] xs:leading-3 sm:leading-3 sm:!text-[7px] lg:!text-[8px] xs:!top-[0.8px] xs:!-right-[1.9px] sm:-top-0 sm:!-right-[3px] lg:-top-[1px] lg:!-right-[5px] xs:w-2 xs:h-2 sm:w-2.5 sm:h-2.5 lg:w-3 lg:h-3 rounded-full flex justify-center items-center">
                {
                  allNotifications?.notifications?.filter((n) => !n.read)
                    ?.length
                }
              </span>
            )}
          </div>
          {notifications && (
            <div
              className="bg-[#121212] scroll-container min-h-[80px] max-h-[300px] z-30 rounded-lg xs:w-48 sm:w-64 lg:w-80 absolute xs:top-7 sm:top-10 lg:top-10 right-0 overflow-hidden"
              onMouseLeave={handleNotificationMouseLeave}
            >
              {allNotifications?.notifications?.length > 0 ? (
                allNotifications?.notifications?.map((notifi, index) => (
                  <div
                    className="flex items-center xs:pt-2.5 xs:pl-2.5 xs:pr-1.5 xs:gap-2 sm:pl-4 sm:pt-4 sm:pr-2.5 sm:gap-x-2.5 lg:pl-5 lg:pt-5 lg:pr-2.5 lg:gap-x-3"
                    key={index}
                  >
                    <div
                      className={`overflow-hidden rounded-full w-8 h-8 sm:w-14 sm:h-14 ${
                        notifi?.data?.logo
                          ? ""
                          : "flex items-center justify-center"
                      } `}
                      style={{
                        backgroundColor:
                          notificationColorData[
                            index % notificationColorData?.length
                          ].bgcolor,
                      }}
                    >
                      {notifi?.data?.logo ? (
                        <img
                          className="w-full h-full object-contain"
                          src={
                            notifi?.data?.type === "new_job_applied"
                              ? `${localimgpath?.talentThumbnail}/${notifi?.data?.logo}`
                              : `${localimgpath?.companyLogo}/${notifi?.data?.logo}`
                          }
                          alt={
                            notifi?.data?.type === "new_job_applied"
                              ? `talent Thumbnail`
                              : `company Logo`
                          }
                        />
                      ) : (
                        <Text
                          text={notifi?.title
                            ?.split(" ")
                            .map((word) => word[0])
                            .join("")
                            .toUpperCase()}
                          isCenter={true}
                          color="text-white"
                          size={fontSizes.h14}
                          weight={TextWeight.Onest_regular}
                        />
                      )}
                    </div>
                    <div className="text-secondary font-onestLight xs:!text-[8px] sm:!text-[10px] lg:text-xs">
                      {notifi?.body}
                    </div>
                  </div>
                ))
              ) : (
                <div className="flex justify-center items-center min-h-[80px]">
                  <p className="text-secondary text-center text-sm">
                    No notifications available.
                  </p>
                </div>
              )}
            </div>
          )}
        </div>

        <div>
          <div
            className="flex items-center xs:gap-1 sm:gap-2 lg:gap-3 relative group"
            onClick={handleMouseEnter}
          >
            <div className="xs:w-4 xs:h-4 sm:w-5 sm:h-5 lg:w-8 lg:h-8 bg-goldMetallic rounded-full flex justify-center items-center overflow-hidden">
              <img
                src={profileimage}
                className="w-full h-full"
                alt={profileimage}
              />
            </div>
            <div>
              <p className="text-secondary xs:text-xs sm:text-sm lg:text-base font-onestRegular">
                {profileName}
              </p>
            </div>
            <div className="relative">
              <div className="xs:!p-[1px] sm:!p-[2px] lg:p-1 bg-secondary rounded-full group-hover:bg-goldMetallic">
                <SlArrowDown
                  className={`text-black xs:!text-[8px] sm:text-xs transition-transform duration-300`}
                />
              </div>
              {Profiler && (
                <div
                  className="bg-[#121212] z-30 rounded-lg lg:w-32 absolute xs:top-9 xs:w-24 sm:w-32 sm:top-10 lg:top-7 xs:right-2 right-0 overflow-hidden"
                  onMouseEnter={() => {
                    setProfiler(true);
                  }}
                  onMouseLeave={handleMouseLeave}
                >
                  <ul>
                    <Link to={"/"}>
                      <li className="hover:bg-[#2a2a2a] font-onestLight cursor-pointer p-2 xs:text-xs sm:text-sm lg:text-base text-secondary">
                        Home
                      </li>
                    </Link>

                    <Link
                      to={
                        userprofile?.role === "talent"
                          ? "/talent-update"
                          : userprofile?.role === "employer"
                          ? "/employer-update"
                          : userprofile?.role === "fan"
                          ? "/user-update"
                          : ""
                      }
                    >
                      <li className="hover:bg-[#2a2a2a] font-onestLight cursor-pointer p-2 xs:text-xs sm:text-sm lg:text-base text-secondary">
                        Update Profile
                      </li>
                    </Link>
                    {userprofile?.role === "talent" && (
                      <Link to={"/my-gallery"}>
                        <li className="hover:bg-[#2a2a2a] font-onestLight cursor-pointer p-2 xs:text-xs sm:text-sm lg:text-base text-secondary">
                          Gallery
                        </li>
                      </Link>
                    )}
                    <li
                      className="hover:bg-[#2a2a2a] font-onestLight cursor-pointer p-2 xs:text-xs sm:text-sm lg:text-base text-secondary"
                      onClick={() => {
                        setIslogout(true);
                        setProfiler(false);
                      }}
                    >
                      Logout
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Logout
        islogout={islogout}
        setIslogout={setIslogout}
        logout={logout}
        dispatch={dispatch}
        isHomePage={true}
        navigate={navigate}
      />
    </div>
  );
}
